import "./ProgressCircle.css";

const ProgressCircle = ({ percentage }) => {
  const radius = 20;
  const stroke = 5;
  const normalizedRadius = radius - stroke / 2;
  const circumference = 2 * Math.PI * normalizedRadius;
  const strokeDashoffset = (1 - percentage / 100) * circumference;

  return (
    <div className="progress-circle">
      <svg width={radius * 2} height={radius * 2}>
        <circle
          r={normalizedRadius}
          cx={radius}
          cy={radius}
          stroke="#e0e0e0"
          strokeWidth={stroke}
          fill="transparent"
        />
        <circle
          r={normalizedRadius}
          cx={radius}
          cy={radius}
          stroke="#8b5cf6"
          strokeWidth={stroke}
          fill="transparent"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
          transform={`rotate(-90 ${radius} ${radius})`}
        />
      </svg>
      <div className="progress-text">{`${percentage}%`}</div>
    </div>
  );
};

export default ProgressCircle;
